import { Chip, ChipProps, Tooltip, useTheme } from "@mui/material";
interface ColoredChipsProps extends ChipProps {
  borderColor?: string;
  bgColor?: string;
  textColor?: string;
  width?: string;
  minWidth?: number;
  display?: string;
  height?: string;
  m?: number;
  tooltipText?: string;
  flexShrink?: number;
  variant?: "outlined" | "filled";
}

const ColoredChips = (props: ColoredChipsProps) => {
  const {
    borderColor,
    bgColor,
    variant = "outlined",
    textColor,
    size = "small",
    width,
    minWidth,
    display,
    height,
    m,
    tooltipText,
    flexShrink,
    ...defaultProps
  } = props;
  const theme = useTheme();
  const defaultChipBackground = theme.palette.action.disabled;
  const chipStyle = {
    color: theme.palette.text.primary,
    borderColor: borderColor ?? defaultChipBackground,
    "& .MuiChip-icon": {
      fontSize: "1rem",
      color: theme.palette.text.primary,
    },
    backgroundColor: bgColor ?? (borderColor ? "transparent" : ""),
    width: width ?? null,
    minWidth: minWidth ?? null,
    display: display ?? null,
    height: height ?? null,
    flexShrink: flexShrink ?? null,
    m: m ?? null,
    ...defaultProps.sx,
  };
  return (
    <Tooltip title={tooltipText ?? ""}>
      <Chip {...defaultProps} sx={chipStyle} size={size} variant={variant === "outlined" || borderColor ? "outlined" : "filled"}/>
    </Tooltip>
  );
};
export default ColoredChips;
